import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormGroupDirective } from '@angular/forms';
import { Yii } from 'libraries/interfaces/Yii';
import { IMultiselectOptions } from "libraries/module/formbuilder/fields/multiselect/multiselect.model";
import { FareTypes } from "libraries/interfaces/i-post-air-search-request";
import { EAirSearchFields } from "app_locobook/air-search/e-air-search-fields";
import { IFieldSpecs } from "libraries/module/formbuilder/fields/interfaces/field-specs";

class Wording {
    public readonly fareTypeLabel: string = Yii.t('wui-shared-js', 'Types de Tarifs');
}

const fareTypeList: IMultiselectOptions[] = [
    {label: FareTypes.public, value: FareTypes.public},
    {label: FareTypes.negoFare, value: FareTypes.negoFare},
    {label: FareTypes.tourOperator, value: FareTypes.tourOperator}
];


@Component({
    selector: 'air-search-fare-type-form',
    templateUrl: './air-search-fare-type-form.component.html',
    styleUrls: ['./air-search-fare-type-form.component.scss']
})
export class AirSearchFareTypeFormComponent implements OnInit {
    public airSearchForm: FormGroup;
    public airSearchFareTypeForm: FormControl;
    public wording: Wording = new Wording();
    public fareTypeList: IMultiselectOptions[] = fareTypeList;
    public eAirSearchFields: typeof EAirSearchFields = EAirSearchFields;
    public fareTypeFieldConfig: IFieldSpecs;

    constructor(
        private readonly formGroupDirective: FormGroupDirective
    ) {
    }

    public ngOnInit(): void {
        this.initAirSearchFareTypeForm();
        this.initFareTypeFieldConfig();
    }

    private initAirSearchFareTypeForm(): void {
        this.airSearchFareTypeForm = new FormControl();
        this.airSearchForm = this.formGroupDirective.form;
        if (this.airSearchForm.contains(EAirSearchFields.price)) {
            (this.airSearchForm.get(EAirSearchFields.price) as FormGroup).addControl(EAirSearchFields.fareType, this.airSearchFareTypeForm);
        } else {
            this.airSearchForm.addControl(EAirSearchFields.price, new FormGroup({}));
            (this.airSearchForm.get(EAirSearchFields.price) as FormGroup).addControl(EAirSearchFields.fareType, this.airSearchFareTypeForm)
        }
    }

    private initFareTypeFieldConfig(): void {
        this.fareTypeFieldConfig = {
            formGroup: (this.airSearchForm.get(EAirSearchFields.price) as FormGroup),
            formControlName: EAirSearchFields.fareType      
        };
    }
}
